/**
 * Single KPI metric display card.
 * Shows icon, value, and title with customizable color scheme.
 */

import type { ReactNode } from 'react';

interface KPICardProps {
  title: string;
  value: number | string;
  icon: ReactNode;
  colorClass: string;
  onClick?: () => void;
}

export function KPICard({ title, value, icon, colorClass, onClick }: KPICardProps) {
  const isClickable = !!onClick;

  return (
    <div
      className={`
        rounded-2xl p-4 text-center transition-all duration-200
        ${colorClass}
        ${isClickable ? 'cursor-pointer hover:scale-105 hover:shadow-md' : ''}
      `}
      onClick={onClick}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={
        isClickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick?.();
              }
            }
          : undefined
      }
    >
      <div className="flex justify-center">{icon}</div>
      <p className="mt-2 text-2xl font-bold">{value}</p>
      <p className="mt-1 text-sm text-gray-600">{title}</p>
    </div>
  );
}
